module.exports = __webpack_public_path__ + "img/logoBlack.f405f362.svg";